import { DefaultCellHeader, DefaultCenteredCellHeader } from "app/components/React/Table/headerCells";
import { CountryCell, DefaultCell, TrafficShare } from "app/components/React/Table/cells";
import { translate } from "app/filters/i18nFilter";
import { PercentageCell } from "app/components/React/Table/cells/PercentageCell";

export const geographyColumns = [
    {
        field: "Country",
        get title() {
            return translate("segment.analysis.geo.table.column.country");
        },
        type: "string",
        cellComponent: CountryCell,
        headerComponent: DefaultCellHeader,
        width: "20%",
        showTotalCount: false,
        visible: true,
    },
    {
        field: "TrafficShare",
        get title() {
            return translate("segment.analysis.geo.table.column.traffic.share");
        },
        type: "double",
        cellComponent: TrafficShare,
        headerComponent: DefaultCellHeader,
        width: "25%",
        visible: true,
    },
    {
        field: "Duration",
        get title() {
            return translate("segment.analysis.geo.table.column.duration");
        },
        type: "double",
        format: "time",
        cellComponent: DefaultCell,
        headerComponent: DefaultCenteredCellHeader,
        width: "25%",
        visible: true,
    },
    {
        field: "PagePerVisit",
        get title() {
            return translate("segment.analysis.geo.table.column.pages.per.visit");
        },
        type: "double",
        format: "number:2",
        sortable: true,
        isSorted: false,
        cellComponent: DefaultCell,
        headerComponent: DefaultCellHeader,
        width: "15%",
        visible: true,
    },
    {
        field: "BounceRate",
        get title() {
            return translate("segment.analysis.geo.table.column.bounce.rate");
        },
        type: "double",
        format: "percentage:2",
        cellComponent: PercentageCell,
        headerComponent: DefaultCellHeader,
        width: "15%",
        visible: true,
    },
];
